import { View, Text, Dimensions, Image } from "react-native";
import React from "react";
import translate from "../../functions/translate";
import MyText from "../../components/custom/MyText";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useIsFocused, useNavigation } from "@react-navigation/native";
import {
  changeHeaderColor,
  showBackButtonWithFunction,
} from "../../redux/header/headerAction";
import { useEffect } from "react";
import { babyBoy, babyGirl, newChild, width } from "../../imports";
import { femaleColor, maleColor, white } from "../../colors";
import { ScrollView, TouchableOpacity } from "react-native-gesture-handler";

export default function NewChildGenderChoose() {
  const navigation = useNavigation();
  const dispatch = useDispatch();
  const main = useSelector((store) => store.main);
  const [selectedChild, setChild] = useState({ gender: "male", name: "ahmad" });

  const isFocused = useIsFocused();
  useEffect(() => {
    if (isFocused) {
      dispatch(changeHeaderColor("#EAFDDB"));
      dispatch(showBackButtonWithFunction(() => navigation.goBack()));
      if (main.token === null) {
        navigation.pop(1);
      }
    }
  }, [isFocused]);
  return (
    <ScrollView
      style={{ flex: 1, width: width }}
      contentContainerStyle={{ flex: 1, width: width }}
    >
      <View
        style={{
          width: width,
          alignItems: "center",
          flex: 1,
          paddingBottom: 100,
        }}
      >
        <View style={{ alignItems: "center", width: "100%" }}>
          <View
            style={{
              height: Dimensions.get("window").height,
              marginTop: -1 * Dimensions.get("window").height,
              backgroundColor: "#EAFDDB",
              width: width,
            }}
          ></View>
          <View style={{ alignItems: "center" }}>
            <View style={{ backgroundColor: "#EAFDDB" }}>
              <View
                style={{
                  backgroundColor: "#EAFDDB",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 10,
                  width: Dimensions.get("screen").width,
                  minHeight: 200,
                  flexDirection: "row",
                  paddingHorizontal: 10,
                }}
              >
                <View style={{ flex: 4.5 }}>
                  <View>
                    <MyText
                      style={{
                        fontSize: 30,
                        marginHorizontal: 10,
                        color: "#504E4E",
                      }}
                    >
                      {translate("add new child")}
                    </MyText>
                  </View>
                  <View
                    direction={main.rtl ? "rtl" : "ltr"}
                    style={{
                      flexDirection: "row",
                      alignItems: "center",
                      marginTop: 10,
                    }}
                  ></View>
                </View>
                <View style={{ flex: 5 }}>
                  <Image
                    source={newChild}
                    style={{ width: "100%", height: 207 }}
                    resizeMode="contain"
                  />
                </View>
              </View>
            </View>
          </View>
        </View>
        <MyText style={{ fontSize: 17, marginVertical: 20 }}>
          {translate("please choose your child gender")}
        </MyText>
        <TouchableOpacity
          onPress={() => {
            navigation.navigate("AddNewChild", { gender: "female" });
          }}
          style={{
            backgroundColor: femaleColor,
            borderRadius: 10,
            width: (width * 9) / 10,
            padding: 10,
            paddingHorizontal: "15%",
            flexDirection: "row",
            minHeight: 100,
            alignItems: "center",
            marginVertical: 20,
          }}
        >
          <MyText style={{ fontSize: 24, color: white }}>
            {translate("girl")}
          </MyText>
          <View style={{ flex: 1 }}></View>
          <Image
            source={babyGirl}
            style={{ width: 80, height: 80 }}
            resizeMode="contain"
          />
        </TouchableOpacity>
        <TouchableOpacity
          onPress={() => {
            navigation.navigate("AddNewChild", { gender: "male" });
          }}
          style={{
            backgroundColor: maleColor,
            borderRadius: 10,
            width: (width * 9) / 10,
            padding: 10,
            paddingHorizontal: "15%",
            flexDirection: "row",
            minHeight: 100,
            alignItems: "center",
            marginVertical: 20,
          }}
        >
          <MyText style={{ fontSize: 24, color: white }}>
            {translate("boy")}
          </MyText>
          <View style={{ flex: 1 }}></View>
          <Image
            source={babyBoy}
            style={{ width: 80, height: 80 }}
            resizeMode="contain"
          />
        </TouchableOpacity>
      </View>
      <View style={{ height: 100 }}></View>
    </ScrollView>
  );
}
